import BarraNavegacion from './BarraNavegacion';
export default BarraNavegacion;